import { render, staticRenderFns } from "./electiveLib.vue?vue&type=template&id=ee5b4d02&scoped=true"
import script from "./electiveLib.vue?vue&type=script&lang=js"
export * from "./electiveLib.vue?vue&type=script&lang=js"
import style0 from "./electiveLib.vue?vue&type=style&index=0&id=ee5b4d02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5b4d02",
  null
  
)

export default component.exports